import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { IndexAdminModel, ModelService, PersonaModel, PersonaService, ReasoningEffort } from 'digiteq-ai-portal-client-lib';
import { MessageService } from 'primeng/api';
import { ErrorService } from '../../services/error.service';
import { finalize } from 'rxjs';
import { Column } from '../../models/column';
import { CrudHandlerComponent } from '../../components/crud-table/crud-handler/crud-handler.component';
import { ShowItemDialogModel } from '../../components/crud-table/crud-table.component';

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrl: './personas.component.scss'
})
export class PersonasComponent extends CrudHandlerComponent<PersonaModel>  implements OnInit, AfterViewInit {
  @ViewChild('reasoningEffortTemplate') reasoningEffortTemplate: TemplateRef<HTMLTemplateElement>;

  columns: Column[] = []
  item?: PersonaModel;
  clonedItem: PersonaModel;
  search = '';

  constructor(
    messageService: MessageService,
    errorService: ErrorService,
    private personaService: PersonaService,
    private readonly modelService: ModelService,
  ) {
    super (messageService, errorService);
    this.itemTypeName = 'Persona';
  }

  ngOnInit() {
    this.personaService.getPersonasAdmin()
    .pipe(
      finalize(() => this.loading = false)
    )
    .subscribe({
      next: (personas) => {
        this.items = personas;
      },
      error: err => {
        this.errorService.handleError(err,'Could not load personas');
      }
    })
  }

  ngAfterViewInit() {
    this.columns = [
      {field: 'name', title: 'Name'},
      {field: 'modelName', title: 'Model'},
      {field: 'maxTokens', title: 'Max tokens'},
      {field: 'prompt', title: 'Prompt'},
      {field: 'reasoningEffortLevel', title: 'Reasoning Effort Level', template: this.reasoningEffortTemplate},
    ];
  }

  getReasoningEffortLabel(value: ReasoningEffort): string {
    return Object.keys(ReasoningEffort).find(key => ReasoningEffort[key] === value) ?? '';
  }

  toggle(item: IndexAdminModel) {
    if (!item.id) {
      return;
    }
    super.handleToggle(this.personaService.updatePersona(item.id, item), item, this.itemTypeName);
  }

  delete(item: IndexAdminModel) {
    if (!item.id) {
      return;
    }
    super.handleDelete(this.personaService.deletePersona(item.id), item.id, this.itemTypeName);
  }

  onPersonaDialogCancel() {
    this.showItemDialog = false;
    this.clonedItem = null;
  }

  onShowItemDialog($event: ShowItemDialogModel) {
    this.showItemDialog = $event.show;
    this.clonedItem = $event.item;
  }

  getDialogHeader() {
    return this.clonedItem ? `Edit ${this.itemTypeName}` : `Add ${this.itemTypeName}`;
  }

  handleAddPersona($event: PersonaModel) {
    this.handleAdd(this.personaService.createPersona($event), this.itemTypeName);
  }

  handleEditPersona($event: PersonaModel) {
    this.handleEdit(this.personaService.updatePersona($event.id, $event), this.itemTypeName);
  }
}
